// DS: i4.9
import React from 'react';
import IconWrap from '../../IconWrap';
const Check = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.45776 11.4655C2.00535 11.1488 1.89541 10.5252 2.21218 10.0728C2.52896 9.6204 3.15251 9.51045 3.60491 9.82723L6.06155 11.5474L11.7981 3.35644C12.1149 2.90404 12.7385 2.79409 13.1909 3.11087C13.6433 3.42764 13.7532 4.05119 13.4364 4.50359L7.1271 13.5143C6.83295 13.9344 6.27429 14.0592 5.83376 13.8212L5.73437 13.7598L2.45776 11.4655Z"
    })));
Check.displayName = 'Check';
export default Check;

//# sourceMappingURL=Check.js.map